import { FlatList, Text, View } from "react-native";
import { useMedicationListingWithOffline } from "../../offline/hooks/useMedicationListingWithOffline";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { MedicationItem } from "../organisms/MedicationItem";
import Pagination from "ui/molecules/pagination/Pagination";
import { MedicationListFrequencyFilter } from "../molecules/MedicationListFrequencyFilter";

export function ResidentCurrentMedicationsTemplate() {
  const { data, meta, handlePageChange, isFetching, frequencies, handleFrequencyChange } =
    useMedicationListingWithOffline();

  return (
    <View className="flex-1">
      <FlatList
        contentContainerClassName="gap-3.5"
        data={data ?? []}
        keyExtractor={(item) => `${item.id}`}
        ListHeaderComponent={<MedicationListFrequencyFilter  filters={frequencies} onChangeFilters={handleFrequencyChange}/>}
        renderItem={({ item }) => <MedicationItem medication={item} />}
        ListEmptyComponent={
          !isFetching ? (
            <Text className="text-center">
              This resident has no active medications
            </Text>
          ) : (
            <LoadingSpinner />
          )
        }
      />
      {data?.length ? (
        <Pagination meta={meta} onPageChange={handlePageChange} />
      ) : null}
    </View>
  );
}
